/** Service Desk console: ang tab na Field service at ang mga insight card ng deflection sa Mga Ulat sa Serbisyo (SD-S3-14, SD-S4-09). Galing sa API ang mga kahulugan sa "i". */
export const serviceReportsField = {
  tabs: { field: "Field service" },
  field: {
    none: "Walang nakatakda",
    noEngineer: "Hindi pa naitatalaga",
    noOrganisation: "Walang organisasyon",
    noModel: "Walang naitalang modelo",
    engineer: "Engineer",
    organisation: "Organisasyon",
    member: "Miyembro ng team",
    model: "Modelo ng asset",
    note: "Galing sa mga pagbisita at time entry ang mga numero; bilang at oras lang ang laman, hindi mga tala o detalye ng kliyente.",
    followUp: { label: "Window ng follow-up", hint: "Kapag may paulit-ulit na pagbisita sa loob nito, hindi naayos ng una.", option: "{{days}} araw" },
    kpi: {
      visits: "Natapos na pagbisita",
      visitsSub: "mula sa {{total}} na nakaplano sa panahon",
      firstTimeFix: "Naayos sa unang bisita",
      fixSub: "{{fixed}} sa {{completed}} na corrective na pagbisita",
      onSite: "On-site na tugon",
      onSiteSub: "{{met}} sa {{ended}} na target ang naabot",
      utilisation: "Utilisation ng engineer",
      utilisationSub: "{{booked}} oras ang naka-book sa {{available}} oras na magagamit",
    },
    visits: { title: "Mga pagbisita bawat engineer", sub: "Nakaplano sa {{period}}", total: "Mga pagbisita", completed: "Natapos", rate: "Rate ng pagtatapos" },
    fix: { title: "Naayos sa unang bisita bawat engineer", sub: "Ang balik-bisita sa loob ng {{days}} araw ay bilang laban dito", rate: "Naayos sa unang bisita", completed: "Natapos", repeat: "Balik-bisita" },
    onSite: { title: "On-site na tugon bawat organisasyon", sub: "Mga target na natapos sa {{period}}", compliance: "Pagsunod", met: "Naabot", breached: "Nalabag" },
    utilisation: { title: "Utilisation bawat engineer", sub: "Naka-book na on-site na oras kontra oras ng trabaho, {{period}}", rate: "Utilisation", booked: "Naka-book", available: "Magagamit" },
    time: { title: "Oras na naitala bawat miyembro", sub: "{{hours}} oras ang naitala sa panahon", hours: "Oras", billable: "Oras na sisingilin", entries: "Mga entry" },
    reliability: { title: "Katatagan ng asset bawat modelo", sub: "Mga insidente bawat 100 unit, {{period}}", per100: "Bawat 100 unit", tickets: "Mga insidente", units: "Mga unit", mtbf: "Karaniwang oras sa pagitan ng sira" },
  },
  insight: {
    label: "Mga mungkahi ng AI at deflection",
    channel: "Channel",
    topic: "Paksa",
    kpi: {
      accept: "Tinanggap na mungkahi sa triage",
      acceptSub: "{{accepted}} sa {{suggested}} na mungkahi",
      high: "Tinanggap na mataas ang kumpiyansa",
      highSub: "{{count}} na mungkahi na 80% pataas",
      completion: "Pagtatapos ng intake",
      completionSub: "{{tickets}} na ticket mula sa {{started}} na usapan",
      dropped: "Umalis sa ticket form",
      droppedSub: "{{form}} ang nakarating sa form",
    },
    triage: { title: "Mga mungkahi sa triage bawat field", sub: "Hiniling sa {{period}}; tinanggap kapag hawak na ng ticket ang halaga", suggestion: "Mungkahi", rate: "Rate ng pagtanggap", suggested: "Iminungkahi", accepted: "Tinanggap" },
    funnel: { title: "Intake funnel bawat channel", sub: "Mga usapang concern na nagsimula sa {{period}}", started: "Nagsimula", form: "Nakarating sa form", tickets: "Mga ticket", rate: "Pagtatapos" },
    deflection: { sub: "Mga usapang concern na nagsimula sa {{period}}", rate: "Rate ng deflection", started: "Nagsimula", deflected: "Na-deflect" },
  },
} as const;
